import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The Medintelekt type scale is declared as custom `fontSize` keys in
 * `tailwind.preset.cjs`. tailwind-merge only knows the stock scale, so it falls
 * back to its `text-*` colour validator and files `text-section` under
 * *text-colour* — where a later `text-muted-foreground` in the same `cn()` call
 * evicts it. The class then never reaches the DOM and the element silently
 * renders at the inherited size.
 *
 * Registering the six steps under `font-size` puts them in the right conflict
 * group: an exact class-part match beats the colour validator, so a size and a
 * colour survive together and two sizes still collapse to the last one.
 *
 * Keep this list in step with the `fontSize` block in `tailwind.preset.cjs`;
 * the clinician app's `src/test/type-scale-merge.spec.ts` fails on drift.
 */
export const TYPE_SCALE_STEPS = [
  'display',
  'page-title',
  'section',
  'body',
  'ui',
  'label',
] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...TYPE_SCALE_STEPS] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
